import s from './Range.module.css';
export const Range = ({ label, onChange, value }) => {
  return (
    <div className={s.item}>
      <label className={s.label}>
        {label} <span className={s.value}>{value}</span> Gb
      </label>
      <div className={s.bar}>
        <input
          className={s.range}
          value={value}
          type="range"
          min="0"
          max="1000"
          step="1"
          onChange={onChange}
        />
      </div>
      <div className={s.output}>
        <input
          min="0"
          max="1000"
          className={s.outputIn}
          value={value}
          onChange={onChange}
          type="number"
          step="1"
        />
      </div>
    </div>
  );
};

// Range container
